import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import * as moment from "moment";

import { Router } from "@angular/router";

@Component({
  selector: "app-failed-payment-popup",
  templateUrl: "./failed.payment.popup.component.html",
  styleUrls: ["./failed.payment.popup.component.scss"],
})
export class FailedPaymentPopup implements OnInit {
  @Output() onClose: EventEmitter<void> = new EventEmitter();
  @Input() eventId: string;

  constructor(private router: Router) {}

  async ngOnInit() {}

  handleClose() {
    this.onClose.emit();
  }

  redirectToPaymentPage() {
    console.log(`Redirecting to payment page`);
    console.log(this.eventId);
    return this.router.navigate([`/user/add-card`], {
      queryParams: {
        eventId: this.eventId
      }
    });
  }
}
